import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }

import InfoIcon from '@/design-system/assets/icons/IconInfoCircle.vue'
import GraphIcon from '@/design-system/assets/icons/IconTimeLine.vue'
type Props = {
  title: string
  hasInfo: boolean
  presentInfo: boolean
}
type Emits = {
  (e: 'onChange', value: boolean): void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'KPICardHeader',
  props: {
    title: {},
    hasInfo: { type: Boolean },
    presentInfo: { type: Boolean }
  },
  emits: ["onChange"],
  setup(__props: any, { emit: __emit }) {


const emits = __emit

function handleSpaceKey(event: Event, value: boolean) {
  event.preventDefault() // Prevent space bar scrolling
  emits('onChange', value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
    (_ctx.hasInfo)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.presentInfo)
            ? (_openBlock(), _createBlock(GraphIcon, {
                key: 0,
                class: "icon",
                role: "button",
                tabindex: "0",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('onChange', false))),
                onKeydown: [
                  _cache[1] || (_cache[1] = _withKeys(($event: any) => (emits('onChange', false)), ["enter"])),
                  _cache[2] || (_cache[2] = _withKeys((event) => handleSpaceKey(event, false), ["space"]))
                ]
              }))
            : (_openBlock(), _createBlock(InfoIcon, {
                key: 1,
                class: "icon",
                role: "button",
                tabindex: "0",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (emits('onChange', true))),
                onKeydown: [
                  _cache[4] || (_cache[4] = _withKeys(($event: any) => (emits('onChange', true)), ["enter"])),
                  _cache[5] || (_cache[5] = _withKeys((event) => handleSpaceKey(event, true), ["space"]))
                ]
              }))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})